import React from 'react'
import { pantryColors, pantryTypography } from '@pantry/ui'

const p = pantryColors
const F = pantryTypography.fontFamily

export const inputStyle = (hasError: boolean): React.CSSProperties => ({
  width: '100%',
  padding: '9px 12px',
  border: `1px solid ${hasError ? '#DC2626' : p.gray[300]}`,
  borderRadius: 6,
  fontSize: 13.5,
  fontFamily: F,
  color: p.gray[800],
  outline: 'none',
  boxSizing: 'border-box',
  transition: 'border-color .15s',
})

export const selectStyle = (hasError: boolean): React.CSSProperties => ({
  ...inputStyle(hasError),
  appearance: 'none' as const,
  background: `#fff url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='%236B7280' viewBox='0 0 24 24'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E") no-repeat right 12px center`,
  paddingRight: 32,
  cursor: 'pointer',
})

interface LabelProps {
  children: React.ReactNode
  required?: boolean
}
export const Label: React.FC<LabelProps> = ({ children, required }) => (
  <label
    style={{
      display: 'block',
      fontSize: 12.5,
      fontWeight: 600,
      color: p.gray[700],
      marginBottom: 6,
      fontFamily: F,
    }}
  >
    {children}
    {required && <span style={{ color: '#DC2626', marginLeft: 2 }}>*</span>}
  </label>
)

interface FieldErrorProps {
  msg?: string
}
export const FieldError: React.FC<FieldErrorProps> = ({ msg }) =>
  msg ? (
    <div style={{ fontSize: 12, color: '#DC2626', marginTop: 4, fontFamily: F }}>
      {msg}
    </div>
  ) : null

interface CheckboxProps {
  checked: boolean
  onChange: (checked: boolean) => void
  label: React.ReactNode
  disabled?: boolean
  bold?: boolean
}
export const Checkbox: React.FC<CheckboxProps> = ({
  checked,
  onChange,
  label,
  disabled,
  bold,
}) => (
  <label
    style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: 8,
      fontSize: 13.5,
      fontWeight: bold ? 600 : 400,
      // Label text stays in its normal color even when the input is disabled —
      // the read-only drawer view greys the checkbox input itself (via the
      // native `disabled` rendering) but should keep permission / location
      // names fully legible.
      color: p.gray[700],
      fontFamily: F,
      cursor: disabled ? 'not-allowed' : 'pointer',
      padding: '4px 0',
      userSelect: 'none',
    }}
  >
    <input
      type="checkbox"
      checked={checked}
      disabled={disabled}
      onChange={(e) => onChange(e.target.checked)}
      style={{
        width: 16,
        height: 16,
        accentColor: '#2563EB',
        cursor: disabled ? 'not-allowed' : 'pointer',
        margin: 0,
      }}
    />
    <span>{label}</span>
  </label>
)
